import { createAction } from '@reduxjs/toolkit'

import { LiquidityProvider } from './reducer'

export const setAvailableProviders = createAction<{ providers: LiquidityProvider[] }>('providers/setAvailableProviders')
export const toggleProvider = createAction<{ providerId: string; defaultSelection: string[] }>(
  'providers/toggleProvider'
)
export const clearSelectedProviders = createAction<void>('providers/clearSelectedProviders')
export const selectAllProviders = createAction<void>('providers/selectAllProviders')
